import dayjs from 'dayjs';
import {
  CampaignFilterEnums,
  CampaignFilterMetricEnums,
  CampaignFilterValueEnums,
} from '../../../../enums/CampaignFilterEnums';

const FILTER_DATE_FORMAT = 'DD/MM/YYYY';

function formatFilterDate(date) {
  return date.format(FILTER_DATE_FORMAT);
}

function buildDemandOverviewMetricFilters(groupId, metricId) {
  const today = dayjs();

  if (groupId === CampaignFilterEnums.ACTIVE) {
    return { status: CampaignFilterValueEnums.ACTIVE };
  }

  if (
    groupId === CampaignFilterEnums.REACHED &&
    metricId === CampaignFilterMetricEnums.TODAY_LIMIT
  ) {
    return { states: CampaignFilterValueEnums.TODAY_LIMIT_REACHED };
  }

  if (groupId === CampaignFilterEnums.SCHEDULED && metricId === CampaignFilterMetricEnums.PAUSED) {
    return { states: CampaignFilterValueEnums.SCHEDULED_PAUSED };
  }

  if (groupId === CampaignFilterEnums.SCHEDULED && metricId === CampaignFilterMetricEnums.TODAY) {
    return { states: CampaignFilterValueEnums.SCHEDULED, startDate: formatFilterDate(today) };
  }

  if (
    groupId === CampaignFilterEnums.SCHEDULED &&
    metricId === CampaignFilterMetricEnums.NEXT_7_DAYS
  ) {
    return {
      states: CampaignFilterValueEnums.SCHEDULED,
      startDate: formatFilterDate(today),
      endDate: formatFilterDate(today.add(7, 'day')),
    };
  }

  if (groupId === CampaignFilterEnums.ENDING && metricId === CampaignFilterMetricEnums.TODAY) {
    return { endDate: formatFilterDate(today) };
  }

  if (
    groupId === CampaignFilterEnums.ENDING &&
    metricId === CampaignFilterMetricEnums.NEXT_3_DAYS
  ) {
    return {
      endDate: formatFilterDate(today.add(3, 'day')),
    };
  }

  if (
    groupId === CampaignFilterEnums.ENDING &&
    metricId === CampaignFilterMetricEnums.NEXT_7_DAYS
  ) {
    return {
      endDate: formatFilterDate(today.add(7, 'day')),
    };
  }

  return {};
}

export { buildDemandOverviewMetricFilters };
